import "./Product.scss";
import { useMutation, useQuery } from "@apollo/client";
import React, { useContext, useState } from "react";
import SearchBox from "../../UI/SearchBox/SearchBox";
import Error from "../../UI/Error/Error";
import { CircularProgress } from "@material-ui/core";
import Empty from "../../UI/Empty/Empty";
import SnackbarContext from "../../../Context/SnackbarContext";
import {
	GetProductsTypeCount,
	GetProductTypes,
	ToggleProductType,
} from "./ProductQuery";
import { useHistory } from "react-router-dom";
import Pagination from "../../UI/Pagination/Pagination";
import { useQueryParams } from "./Product";

const ProductTypeMain = () => {
	const [searchString, setSearchString] = useState<string>("");
	const query = useQueryParams();
	const [offset, setOffset] = useState(
		query.get("offset") ? parseInt(query?.get("offset") ?? "0") : 0
	);
	const history = useHistory();
	const [limit] = useState(8);

	const {
		data: productTypes,
		error,
		loading,
		refetch,
	} = useQuery(GetProductTypes, {
		variables: {
			searchString: `%${searchString}%`,
			limit,
			offset,
		},
		fetchPolicy: "network-only",
	});

	console.log(productTypes);

	const {
		data: productTypeCount,
		loading: countLoading,
		refetch: countRefetch,
	} = useQuery(GetProductsTypeCount, {
		variables: {
			searchString: `%${searchString}%`,
		},
	});

	const callRefetch = () => {
		console.log("here");
		refetch();
		countRefetch();
	};

	if (error) {
		return <Error error={error} />;
	}

	return (
		<div className="container-main">
			<div className="season__header">
				<div className="w-40">
					<SearchBox
						placeholder="Search product type with name"
						onChangeSearch={(value) => {
							setSearchString(value);
						}}
					/>
				</div>
			</div>

			<div className="coupon__box">
				<div className="coupon__main">
					<div className="season__header">
						<p className="title">Product Types</p>
						<button
							type="button"
							onClick={() => {
								history.push(
									"/dashboard/products/product-type-detail?mode=add&productTypeId=0"
								);
							}}
						>
							+Add Product Type
						</button>
					</div>
					<ProductTitle />
					{loading ? (
						<div className="spinner-container">
							<CircularProgress size={40} thickness={4} />
						</div>
					) : productTypes.product_type.length > 0 ? (
						productTypes.product_type.map((element: any) => {
							return (
								<ProductItem
									element={element}
									key={element.id}
									refetch={callRefetch}
									onClickEdit={() => {
										history.push(
											`/dashboard/products/product-type-detail?mode=edit&productTypeId=${element.id}`
										);
									}}
								/>
							);
						})
					) : (
						<Empty />
					)}
				</div>

				{!loading && !countLoading && (
					<Pagination
						limit={limit}
						offset={offset}
						count={
							productTypeCount.product_type_aggregate.aggregate
								.count
						}
						changeOffset={(value) => setOffset(value)}
					/>
				)}
			</div>
		</div>
	);
};

const ProductTitle: React.FC = () => {
	return (
		<div className="product-type__table">
			<p className="season__table-title">ID</p>
			<p className="season__table-title">Name</p>
			<p className="season__table-title">Cost</p>
			<p className="season__table-title">Product</p>
			{/* {<p className="season__table-title">Sub-Category</p>
			<p className="season__table-title">Category</p>} */}
		</div>
	);
};

interface ItemProps {
	element: any;
	refetch: () => void;
	onClickEdit: () => void;
}

const ProductItem: React.FC<ItemProps> = (props: ItemProps) => {
	const { element, onClickEdit, refetch } = props;
	const { setSnackbar, setMessage } = useContext(SnackbarContext);
	const [toggleProduct] = useMutation(ToggleProductType);
	const [loading, setLoading] = useState(false);

	const onToggle = () => {
		setLoading(true);
		toggleProduct({
			variables: {
				productTypeId: element.id,
				isDeleted: !element.isDeleted,
			},
		})
			.then(({ data }) => {
				setSnackbar(true);
				setMessage("Product updated Successfully");
				setLoading(false);
				refetch();
			})
			.catch((error) => {
				setSnackbar(true);
				setMessage(error.message);
				setLoading(false);
			});
	};

	return (
		<div className="product-type__table">
			<p className="season__table-item">{element.id}</p>
			<p className="season__table-item">{element.name}</p>
			<p className="season__table-item">{element.discountedPrice}</p>
			{/* <p className="season__table-item">
				{element.product.productsSubCategories?.subCategory?.name}
			</p> */}
			<p className="season__table-item">{element.product.name}</p>
			{/* <p className="season__table-item">
				{element.product.productsSubCategories?.subCategory
					?.categoriesSubCategories?.category
					? element.product.productsSubCategories?.subCategory
							?.categoriesSubCategories?.category?.name
					: ""}
			</p> */}

			<div className="season__actions">
				<button className="btn-list" onClick={onClickEdit}>
					View
				</button>

				{loading ? (
					<div style={{ width: "4rem" }}>
						<CircularProgress size={20} thickness={3} />
					</div>
				) : (
					<button
						className="btn-list"
						onClick={() => {
							onToggle();
						}}
					>
						{element.isDeleted ? "Enable" : "Disable"}
					</button>
				)}
			</div>
		</div>
	);
};

export default ProductTypeMain;
